.a6{width:100%;}